
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$alert.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$alert.js';
export default __default__;
